import { useLayoutEffect, useState } from 'react'
import { PC_BREAKPOINT } from '@weberus/utils'

/**
 * PC 넓이 인지 확인하는 hook
 * @param breakpoint PC로 간주할 최소 너비(px). 기본값 PC_BREAKPOINT(801px).
 *                   pf-pc(1024) 레이아웃 지면은 1024를 전달해 CSS `pf-pc:` 분기점과 일치시킨다.
 */
const useIsPcWidth = (breakpoint: number = PC_BREAKPOINT) => {
  const [isPcWidth, setIsPcWidth] = useState(false)

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`)
    setIsPcWidth(mediaQuery.matches)

    const handleMediaQueryChange = (event: MediaQueryListEvent) => {
      setIsPcWidth(event.matches)
    }

    mediaQuery.addEventListener('change', handleMediaQueryChange)
    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange)
    }
  }, [breakpoint])

  return { isPcWidth }
}

export default useIsPcWidth
